/**
 * Internal ops document_correction review-decision permissions (V0).
 * Colon-form InternalEntity catalog keys — NOT portal underscore customer caps.
 */

import {
  DOCUMENT_CORRECTION_OPS_READ_PERMISSION,
  DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION,
} from './document-correction-ops-info-request-permissions';

export { DOCUMENT_CORRECTION_OPS_READ_PERMISSION, DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION };

export const DOCUMENT_CORRECTION_OPS_REVIEW_PERMISSION = 'document_correction:review' as const;

export const DOCUMENT_CORRECTION_OPS_REVIEW_DECISION_PERMISSIONS = [
  DOCUMENT_CORRECTION_OPS_REVIEW_PERMISSION,
] as const;

export type DocumentCorrectionOpsReviewDecisionPermission =
  (typeof DOCUMENT_CORRECTION_OPS_REVIEW_DECISION_PERMISSIONS)[number];

export function hasDocumentCorrectionOpsReviewPermission(
  permissions: readonly string[] | undefined
): boolean {
  if (!permissions?.length) return false;
  const granted = new Set(permissions);
  return granted.has(DOCUMENT_CORRECTION_OPS_REVIEW_PERMISSION) || granted.has('system:admin');
}

/** Read queue/context: read, request_info, or review (writers/reviewers can list). */
export function hasDocumentCorrectionOpsReviewContextReadPermission(
  permissions: readonly string[] | undefined
): boolean {
  if (!permissions?.length) return false;
  const granted = new Set(permissions);
  return (
    granted.has(DOCUMENT_CORRECTION_OPS_READ_PERMISSION) ||
    granted.has(DOCUMENT_CORRECTION_OPS_REQUEST_INFO_PERMISSION) ||
    granted.has(DOCUMENT_CORRECTION_OPS_REVIEW_PERMISSION) ||
    granted.has('system:admin')
  );
}
